export default function header() {
    const header = $('.header');
    const viewMore = $('.banner__view-more');

    $(window).on('scroll', function() {
        const scroll = $(this).scrollTop();
        const threshold = viewMore.offset();
        const { top } = threshold;

        if (scroll >= top) {
            header.addClass('sticky');
        } else {
            header.removeClass('sticky');
        }
    });
}